/* eslint-disable no-undef */
import {getTranslation} from './translations';

const ref = typeof Vue !== 'undefined' ? Vue.ref : null;
const watch = typeof Vue !== 'undefined' ? Vue.watch : null;

const template = `
	<div class="ubf-dynamicList__filter ubf-dynamicList__filter--singleselect">
		<div class="ubf-dynamicList__radioGroup" role="radiogroup" :aria-label="label">
			<label class="ubf-dynamicList__radioGroup__item">
				<input type="radio" :name="label" value="" :checked="localValue === '' || localValue == null" @change="onAllValue()" />
				{{ trans('all') }}
			</label>
			<label class="ubf-dynamicList__radioGroup__item" v-for="option in preset">
				<input type="radio" :name="label" :value="option.id" :checked="localValue === option" @change="onChangeValue(option)" />
				{{ option.label }}
			</label>
		</div>
	</div>
`;

export default {
	emits: ['change'],
	template: template,
	props: {
		label: String,
		value: String,
		description: String,
		preset: Array
	},
	setup: function (props, context) {
		const localValue = ref(props.value);
		watch(
			() => props.value, (newVal) => {
				localValue.value = newVal;
			}
		);
		return {
			trans: getTranslation,
			localValue: localValue,
			label: props.label,
			description: props.description,
			preset: props.preset
		};
	},
	methods: {
		onAllValue: function (val) {
			this.$emit('change', []);
		},
		onChangeValue: function (val) {
			this.$emit('change', val.id);
		},
	},
};

